// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 664 ? "reactPlayerPreview" : chunkId) + "." + {"165":"3239c557ef580bf4","664":"c06f52e185097cda","910":"905567b272f9ae52"}[chunkId] + ".js";
};